import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-windows",
  "use": "icon-windows-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-windows\"><path d=\"M64 187.4l367.2-50.6v354.8H64V187.4z m0 649.2l367.2 50.6V536.8H64v299.8z m407.6 56L960 960V536.8H471.6v355.8z m0-761.2v360.2H960V64L471.6 131.4z\" p-id=\"2694\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol